var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-title"},[_vm._v("小程序认证")]),_c('com-auth',{attrs:{"app":_vm.app,"company-info":_vm.companyInfo,"com":""},on:{"success":_vm.authSuccess}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }